import React from "react";

import BaseDialog from "./BaseDialog";
import CSVUploadButtonAndPreview from "../CSVUploadButtonAndPreview";

export default class CSVUploadAndPreviewDialog extends BaseDialog {
  /**
   * Dialog for CSV upload and preview
   * @module CSVUploadAndPreviewDialog
   * @param {Object} props React render
   */
  constructor(props) {
    super(props);
    
    this.state = {
      parsedUploadedFile: '',
      originalUploadedFile: '',
      channel: '',
    };
    
    this.onSelectFile = this.onSelectFile.bind(this);
    this.onSelectChannel = this.onSelectChannel.bind(this);
  }
  
  /**
   * React life-cycle method.
   */
  componentDidMount() {
    super.componentDidMount();

    // The `onSubmit` handler is defined on the upper component based on its needs.
    document.addEventListener("ev-dialog-add", this.onSubmit);
    this.toggleSubmitButtonState(false);
  }
  
  /**
   * This method gets called on the parent `BaseDialog` component
   * on the `componentWillUnmount` life-cycle method.
   */
  unregister() {
    // The `onSubmit` handler is defined on the upper component based on its needs.
    document.removeEventListener("ev-dialog-add", this.onSubmit);
  }

  /**
   * Handler for selecting a file from the `CSVUploadButtonAndPreview` component.
   * @param {boolean} isValidFile Whether the selected file is a valid CSV or not.
   * @param {Papa.ParseResult<T>} parsedFile The parsed version of the uploaded CSV file.
   * @param {string|ArrayBuffer|null} originalFile The original uploaded file.
   */
  onSelectFile(isValidFile, parsedFile, originalFile) {
    if (!isValidFile) {
      this.toggleSubmitButtonState(false);
      window.apm.notification.post('error', window.l.notification.csv_invalid);
      return;
    }

    this.toggleSubmitButtonState(true);
    this.setState({
      parsedUploadedFile: parsedFile,
      originalUploadedFile: originalFile,
    });
  }

  onSelectChannel(channel) {
    this.setState({ channel });
  }
  
  /**
   * Enable or disable the primary action button inside the modal.
   * @param {boolean} isEnabled Whether the button should be enabled or not.
   */
  toggleSubmitButtonState(isEnabled) {
    const submitButton = $('.w2ui-btn.primary.add-button');
    if (!isEnabled) {
      submitButton.attr('disabled', 'disabled');
    } else {
      submitButton.removeAttr('disabled');
    }
  }

  /**
   * React render
   * @returns {JSX.Element}
   */
  render() {
    return (
      <div className="container-fluid">
        <div className="script-wrapper">
          <div>
            <CSVUploadButtonAndPreview
              onSelectFile={this.onSelectFile}
              onSelectChannel={this.onSelectChannel}
              previewStyles={{ width: "100%", overflow: "auto", maxHeight: "450px" }}
              validateRowFunction={this.getValidatedRow} // Optionally defined in the upper component
              onDetectInvalidRows={this.onDetectInvalidRows} // Optionally defined in the upper component
              shouldRenderFileName
              shouldRenderChannelInfo={window.apm.serialized.omniChannel.isOmniChannel}
            />
          </div>
        </div>
      </div>
    );
  }
}
